module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar', {
    ref: "navbar"
  }), _vm._v(" "), _c('div', {
    ref: "wrapper",
    staticClass: "content-wrapper",
    style: ({
      minHeight: _vm.viewHeight + 'px',
      backgroundImage: ("url(" + _vm.contentBgImg + ")")
    })
  }, [_c('div', {
    ref: "view",
    staticClass: "view-container"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('toolBar'), _vm._v(" "), _c('v-footer', {
    ref: "footer",
    attrs: {
      "show": !_vm.$store.state.route.meta.hideFooter
    }
  }), _vm._v(" "), _c('Appointment')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-183fa22b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 585
// module chunks = 1